import { Outlet } from "react-router-dom";

const DEMO_USER = JSON.stringify({
  id: 4771, name: "Monica", surname: "Raigosa", email: "mvjc@novonordisk.com",
  locale: "es", phone: "65965314", country: "Panama", city: "Ciudad de panama",
  profession: "Médico", channel: "Whatsapp", specialty: "Alergología e inmunología clínica",
  continued_sign_ins: 0, experience: 10, level: 1, study_time: 0,
  biography: null, avatar: { url: null }
});

export const ProtectedRoutes = ({ user, children }) => {
  const effectiveUser = user || DEMO_USER;

  return children ? children : <Outlet context={{ user: effectiveUser }}/>;
};
